import React, { useEffect, useState } from 'react';
import ModalFormUser from '../../components/forms/users/modal.form.users';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListUsers() {
  const [msgGet ,setMsgGet] = useState('');
  const [users, setUsers] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });
  useEffect(() => {
    getUsers()
  }, []);

  const createUser = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getUsers()
  };

  const editButton = (row) => {
    return (
      <ModalFormUser
        title="Modificar Usuario"
        button_text="Editar"
        button_variant="outline-primary"
        userSelect={row.id}
        callback={createUser}
      ></ModalFormUser>
    );
  };

  const getUsers = async()=>{
    const responseUsers = await get('/users/',{})
    if(responseUsers.success){
      setUsers(responseUsers.data);
    }else{
      setMsgGet(responseUsers.message)
    }       
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormUser
        title="Crear Usuario"
        button_text="Crear Usuario"
        button_variant="primary"
        id={null}
        callback={createUser}
      ></ModalFormUser>
      <ListTables
        data={users}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListUsers;
